








































































































































































































































































































import axios from 'axios'
import Component from 'vue-class-component'
import { Prop, Vue } from 'vue-property-decorator'
import { required, between, requiredIf, integer } from 'vuelidate/lib/validators'

import AsiakirjatContent from '@/components/asiakirjat/asiakirjat-content.vue'
import AsiakirjatUpload from '@/components/asiakirjat/asiakirjat-upload.vue'
import ElsaButton from '@/components/button/button.vue'
import ElsaFormDatepicker from '@/components/datepicker/datepicker.vue'
import ElsaFormError from '@/components/form-error/form-error.vue'
import ElsaFormGroup from '@/components/form-group/form-group.vue'
import ElsaFormMultiselect from '@/components/multiselect/multiselect.vue'
import ElsaPopover from '@/components/popover/popover.vue'
import { Asiakirja, Tyoskentelyjakso, TyoskentelyjaksoForm } from '@/types'
import { KaytannonKoulutusTyyppi, TyoskentelyjaksoTyyppi } from '@/utils/constants'
import { mapFiles } from '@/utils/fileMapper'
import { sortByAsc } from '@/utils/sort'
import {
  tyoskentelyjaksoKaytannonKoulutusLabel,
  tyoskentelypaikkaTyyppiLabel
} from '@/utils/tyoskentelyjakso'

@Component({
  components: {
    AsiakirjatContent,
    AsiakirjatUpload,
    ElsaButton,
    ElsaFormGroup,
    ElsaFormError,
    ElsaFormMultiselect,
    ElsaFormDatepicker,
    ElsaPopover
  },
  validations: {
    form: {
      tyoskentelypaikka: {
        required,
        nimi: {
          required
        },
        kunta: {
          required
        },
        tyyppi: {
          required
        },
        muuTyyppi: {
          required: requiredIf((value) => {
            return value.tyyppi === 'MUU'
          })
        }
      },
      osaaikaprosentti: {
        required,
        integer,
        between: between(50, 100)
      },
      kaytannonKoulutus: {
        required
      },
      omaaErikoisalaaTukeva: {
        required: requiredIf((value) => {
          return (
            value.kaytannonKoulutus === KaytannonKoulutusTyyppi.OMAA_ERIKOISALAA_TUKEVA_KOULUTUS
          )
        })
      }
    }
  }
})
export default class TyoskentelyjaksoFormClass extends Vue {
  $refs!: {
    alkamispaiva: ElsaFormDatepicker
    paattymispaiva: ElsaFormDatepicker
  }

  @Prop({ required: false, default: true })
  allowHyvaksyttyAiemminToiselleErikoisalalleOption!: boolean

  @Prop({ required: false, default: false })
  editing!: boolean

  @Prop({ required: false, default: () => [] })
  kunnat!: any[]

  @Prop({ required: false, default: () => [] })
  erikoisalat!: any[]

  @Prop({ required: false, default: undefined })
  asiakirjat?: Asiakirja[]

  @Prop({ required: false, default: undefined })
  reservedAsiakirjaNimet?: string[]

  @Prop({
    required: false,
    type: Object,
    default: () => ({
      alkamispaiva: null,
      paattymispaiva: null,
      osaaikaprosentti: null,
      tyoskentelypaikka: {
        nimi: null,
        kunta: {},
        tyyppi: null,
        muuTyyppi: null
      },
      kaytannonKoulutus: null,
      omaaErikoisalaaTukeva: null,
      hyvaksyttyAiempaanErikoisalaan: null
    })
  })
  value!: Tyoskentelyjakso

  addedFiles: File[] = []
  newAsiakirjatMapped: Asiakirja[] = []
  deletedAsiakirjat: Asiakirja[] = []
  reservedAsiakirjaNimetMutable: string[] | undefined = []

  form: TyoskentelyjaksoForm = {
    alkamispaiva: null,
    paattymispaiva: null,
    minPaattymispaiva: null,
    maxAlkamispaiva: null,
    osaaikaprosentti: 100,
    tyoskentelypaikka: {
      nimi: null,
      kunta: { abbreviation: null },
      tyyppi: null,
      muuTyyppi: null
    },
    kaytannonKoulutus: null,
    omaaErikoisalaaTukeva: null,
    hyvaksyttyAiempaanErikoisalaan: null
  }
  tyypit = [
    { text: this.$t('terveyskeskus'), value: TyoskentelyjaksoTyyppi.TERVEYSKESKUS },
    {
      text: this.$t('keskussairaala-tai-aluesairaala'),
      value: TyoskentelyjaksoTyyppi.KESKUSSAIRAALA
    },
    {
      text: this.$t('yliopistollinen-sairaala'),
      value: TyoskentelyjaksoTyyppi.YLIOPISTOLLINEN_SAIRAALA
    },
    { text: this.$t('yksityinen'), value: TyoskentelyjaksoTyyppi.YKSITYINEN }
  ]
  params = {
    saving: false,
    deleting: false
  }
  childDataReceived = false

  async mounted() {
    this.form = {
      ...this.value
    }

    this.reservedAsiakirjaNimetMutable = this.reservedAsiakirjaNimet
    if (!this.reservedAsiakirjaNimetMutable) {
      this.reservedAsiakirjaNimetMutable = (
        await axios.get('erikoistuva-laakari/asiakirjat/nimet')
      ).data
    }

    this.childDataReceived = true
  }

  validateState(name: string) {
    // TODO: Vaatii refaktorointia
    const get = (obj: any, path: any, defaultValue = undefined) => {
      const travel = (regexp: any) =>
        String.prototype.split
          .call(path, regexp)
          .filter(Boolean)
          .reduce((res, key) => (res !== null && res !== undefined ? res[key] : res), obj)
      const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/)
      return result === undefined || result === obj ? defaultValue : result
    }
    const { $dirty, $error } = get(this.$v.form, name)
    return $dirty ? ($error ? false : null) : null
  }

  validateForm(): boolean {
    this.$v.form.$touch()
    return !this.$v.$anyError
  }

  onSubmit() {
    const validations = [
      this.validateForm(),
      this.$refs.alkamispaiva ? this.$refs.alkamispaiva.validateForm() : true,
      this.$refs.paattymispaiva.validateForm()
    ]

    if (validations.includes(false)) {
      return
    }

    const submitData = {
      tyoskentelyjakso: {
        ...this.form,
        tyoskentelypaikka: {
          ...this.form.tyoskentelypaikka,
          kuntaId: this.form.tyoskentelypaikka.kunta?.id
        },
        omaaErikoisalaaTukevaId: this.form.omaaErikoisalaaTukeva?.id
      },
      addedFiles: this.addedFiles,
      deletedAsiakirjaIds: this.deletedAsiakirjat.map((asiakirja) => asiakirja.id)
    }

    delete submitData.tyoskentelyjakso.asiakirjat

    this.$emit('submit', submitData, this.params)
  }

  onFilesAdded(files: File[]) {
    const addedFilesInDeletedArray = files.filter((added) =>
      this.deletedAsiakirjat.map((deleted) => deleted.nimi).includes(added.name)
    )
    const addedFilesNotInDeletedArray = files.filter(
      (added) => !addedFilesInDeletedArray.includes(added)
    )

    this.deletedAsiakirjat = this.deletedAsiakirjat?.filter(
      (deletedAsiakirja) =>
        !addedFilesInDeletedArray
          .map((addedFile) => addedFile.name)
          .includes(deletedAsiakirja.nimi)
    )
    this.addedFiles = [...this.addedFiles, ...addedFilesNotInDeletedArray]
    this.newAsiakirjatMapped = [
      ...mapFiles(addedFilesNotInDeletedArray),
      ...this.newAsiakirjatMapped
    ]
    this.$emit('skipRouteExitConfirm', false)
  }

  async onDeleteLiitetiedosto(asiakirja: Asiakirja) {
    // Jos asiakirjalla on id, on se tallennettu kantaan jo aiemmin, joten
    // lisää asiakirja poistettaviin asiakirjoihin.
    if (asiakirja.id) {
      this.deletedAsiakirjat = [asiakirja, ...this.deletedAsiakirjat]
    } else {
      // Jos asiakirjalla ei ole id:tä, on se lisätty ensimmäistä kertaa
      // tässä näkymässä, joten poista asiakirja lisättävistä tiedostoista.
      this.addedFiles = this.addedFiles?.filter((file) => file.name !== asiakirja.nimi)
      this.newAsiakirjatMapped = this.newAsiakirjatMapped?.filter(
        (a) => a.nimi !== asiakirja.nimi
      )
    }
    this.$emit('skipRouteExitConfirm', false)
  }

  onOsaaikaprosenttiInput(value: string) {
    if (value === '') {
      this.form.osaaikaprosentti = null
    } else {
      this.form.osaaikaprosentti = parseFloat(value)
    }
    this.$emit('skipRouteExitConfirm', false)
  }

  onCancel() {
    this.$emit('cancel')
  }

  get maxAlkamispaiva() {
    if (this.value.tapahtumia) {
      return this.form.maxAlkamispaiva
    } else {
      return this.form.paattymispaiva
    }
  }

  get minPaattymispaiva() {
    if (this.value.tapahtumia) {
      return this.form.minPaattymispaiva
    } else {
      return this.form.alkamispaiva
    }
  }

  get kunnatFormatted() {
    return this.kunnat
      .filter((k) => !k.korvaavaKoodi) // Rajattu pois entiset kunnat
      .filter((k) => !['000', '198', '199'].includes(k.id)) // Rajattu pois muut kuin kunnat
      .sort((a, b) => sortByAsc(a.abbreviation, b.abbreviation))
  }

  get erikoisalatFormatted() {
    return [
      ...this.erikoisalat
        .filter((erikoisala) => erikoisala.nimi !== 'Yleislääketieteen erityiskoulutus')
        .sort((a, b) => sortByAsc(a.nimi, b.nimi)),
      {
        nimi: this.$t('muu')
      }
    ]
  }

  get asiakirjatTableItems() {
    return [...this.newAsiakirjatMapped, ...this.asiakirjatExcludingDeleted()]
  }

  get existingFileNamesInCurrentView() {
    return this.asiakirjatTableItems?.map((item) => item.nimi)
  }

  get existingFileNamesInOtherViews() {
    return this.reservedAsiakirjaNimetMutable?.filter(
      (nimi) => !this.existingFileNamesInCurrentView.includes(nimi)
    )
  }

  get omaaErikoisalaaTukeva() {
    return KaytannonKoulutusTyyppi.OMAA_ERIKOISALAA_TUKEVA_KOULUTUS
  }

  get omanErikoisalanKoulutus() {
    return KaytannonKoulutusTyyppi.OMAN_ERIKOISALAN_KOULUTUS
  }

  get tutkimustyo() {
    return KaytannonKoulutusTyyppi.TUTKIMUSTYO
  }

  get terveyskeskustyo() {
    return KaytannonKoulutusTyyppi.TERVEYSKESKUSTYO
  }

  get kaytannonKoulutusLabel() {
    if (this.form?.kaytannonKoulutus) {
      return tyoskentelyjaksoKaytannonKoulutusLabel(this, this.form?.kaytannonKoulutus)
    }
    return undefined
  }

  get tyyppiLabel() {
    if (this.form?.tyoskentelypaikka?.tyyppi) {
      return tyoskentelypaikkaTyyppiLabel(this, this.form?.tyoskentelypaikka?.tyyppi)
    }
    return undefined
  }

  private asiakirjatExcludingDeleted(): Asiakirja[] {
    return (this.asiakirjat ?? []).filter(
      (asiakirja) =>
        !this.deletedAsiakirjat.map((deleted) => deleted.nimi).includes(asiakirja.nimi)
    )
  }
}
